import { render } from "./AttributeDetail.vue?vue&type=template&id=70d81f29"
import script from "./AttributeDetail.vue?vue&type=script&lang=js"
export * from "./AttributeDetail.vue?vue&type=script&lang=js"

import "./AttributeDetail.vue?vue&type=style&index=0&id=70d81f29&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__